/**
 * Centralized environment configuration.
 *
 * All REACT_APP_ variables are compiled into the browser bundle at build time
 * and are therefore publicly visible. Do not place real secrets here.
 *
 * See SECURITY_REVIEW.md for a full explanation of each value's risk level.
 */

const env = {
  /** Base URL for the authentication service (login, forgot-password, refresh). */
  AUTH_URL: process.env.REACT_APP_AUTH_URL || "",

  /** Base URL for the ETD application management API. */
  MANAGEMENT_URL: process.env.REACT_APP_MANAGEMENT_URL || "",

  /** Base URL for the ETD portal image/document service. */
  IMAGE_URL: process.env.REACT_APP_IMAGE_URL || "",

  /**
   * Basic Auth credential for the auth and image service endpoints.
   * SECURITY WARNING: This credential is visible in the browser bundle.
   * See SECURITY_REVIEW.md — a backend change is required to remove this.
   */
  BASIC_AUTH_USER: process.env.REACT_APP_BASIC_AUTH_USER || "",
  BASIC_AUTH_PASS: process.env.REACT_APP_BASIC_AUTH_PASS || "",
};

export default env;
